module.exports = __webpack_public_path__ + "static/media/appts-list.d4a8e58f.svg";